import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExportUserReportPayload,
  BackendMutationExportUserReportArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExportUserReport($customerId: ID!) {
    exportUserReport(customerId: $customerId) {
      filename
      content
    }
  }
`;

type Variables = BackendMutationExportUserReportArgs;
type Result = BackendExportUserReportPayload;

export const exportUserReport = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
